// extracted by mini-css-extract-plugin
export default {"container":"CardTabsContainer_container__bYdDl"};